import { FC, PropsWithChildren } from 'react';
import { cn } from '@/shared/lib/utils';

type Props = {
  role?: string;
  className?: string;
  classNames?: {
    /** Класс подписи роли; переопределяет умолчание её размера */
    role?: string;
  };
};

/**
 * Компонент для отображения заголовка сообщения (автор и роль)
 */
export const ChatMessageTitle: FC<PropsWithChildren<Props>> = ({ children, role, className, classNames }) => {
  if (!children && !role) {
    return null;
  }

  return (
    // Имя и роль переносятся в пределах облака, а не уходят за его край: роль, не уместившаяся рядом
    // с именем, — строкой ниже, а слово шире облака рвётся внутри. Потолок ширины обязателен: строка,
    // прижатая к началу, иначе не уже самого длинного слова, и такое слово выводит её за облако
    <div className={cn('flex flex-wrap items-center gap-x-5 gap-y-1 text-sm mr-auto mb-2 max-w-full', className)}>
      {children && <span className="min-w-0 wrap-break-word">{children}</span>}
      {role && <span className={cn('min-w-0 wrap-break-word text-xs', classNames?.role)}>{role}</span>}
    </div>
  );
};
